<template>
    <div class="bg-white px2-pc px1-mobile pb-1">
        <div class="backlink mt3-pc">
            <a layout="row" layout-align="start center" @click="$router.push({name: 'admin-settings-regional-directorates-index'})"><v-icon class="mr-1" color="grey">mdi-chevron-left</v-icon>{{$t('params.back_rds')}}</a>
        </div>
        <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb-2 mt3-pc mt1-mobile">{{isNew ? $t('params.new_rd') : $t('params.edit_rd')}}</div>

        <v-form class="mt5-pc mt3-mobile" layout="column" layout-align="center center" ref="form" v-model="formValid" @submit.prevent="save">
            <div class="width-95-mobile">
                <div v-for="l in $store.state.folangs" :key="l.id">
                    <div class="font-weight-bold mb-2 mt-3">{{$t('params.name_in')}} {{i18n(l.name)}} *</div>
                    <v-text-field :label="l.id.toUpperCase()" v-model="rd.label[l.id]" class="field-width" :rules="[ v => !!v || $t('errors.required') ]"></v-text-field>
                </div>
            </div>
            <div layout="row" layout-align="end center" class="field-width width-95-mobile">
                <v-btn depressed color="secondary" @click="save" style="text-transform: none">{{$t('_.save')}}</v-btn>
                &nbsp;{{$t('_.or')}}&nbsp;
                <router-link :to="{name: 'admin-settings-regional-directorates-index'}" class="grey--text">{{$t('_.cancel')}}</router-link>
            </div>
        </v-form>
    </div>
</template>

<script>
    import Params from '@/api/params'
    import I18nMixin from '@/mixins/i18n'

    export default {
        mixins: [I18nMixin],
        data () {
            return {
                rd: {
                    id: null,
                    label: {}
                },
                formValid: false,
            }
        },
        mounted () {
            if (!this.isNew) {
                this.fetch();
            }
        },
        methods: {
            fetch () {
                Params.get('regional-directorates', this.$route.params.id).then(res => {
                    this.rd = res.data;
                })
            },
            save () {
                if (!this.$refs.form.validate()) {
                    return;
                }

                if (this.isNew) {
                    Params.create('regional-directorates', this.rd).then(() => {
                        this.$router.push({name: 'admin-settings-regional-directorates-index'});
                        this.$snotify.success(this.$t('params.rd_created'));
                    })
                } else {
                    Params.update('regional-directorates', this.rd.id, this.rd).then(() => {
                        this.$router.push({name: 'admin-settings-regional-directorates-index'});
                        this.$snotify.success(this.$t('params.rd_edited'));
                    })
                }
            },
        },
        computed: {
            isNew () {
                return this.$route.params.id === 'new';
            },
        }
    }
</script>